import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import TopBarIcons from "./TopBarIcons";
import "../css/requisition-app-styles.css";
import ConfirmModal from "./ConfirmModal"; 
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import LoadingOverlay from "./LoadingOverlay";


const ViewUsers = () => {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const usersPerPage = 5;
  const [errorMessage, setErrorMessage] = useState("");
  const theUserType = localStorage.getItem("userType");
  const navigate = useNavigate();
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  
const handleDeleteClick = (userId) => {
    setUserToDelete(userId);      
    setShowConfirmModal(true);    
  };
  
  
  const getFullImageUrl = (path) => {
    if (!path) return null;
    return path.startsWith("http") ? path : `${process.env.REACT_APP_STATIC_BASE_URL}/${path}`;
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/users`);
      console.log("Users response data:", response.data);
  
      const payload = response.data;
      const usersArray = Array.isArray(payload)
        ? payload
        : Array.isArray(payload?.$values)
        ? payload.$values
        : []; 
  
      setUsers(usersArray);
    } catch (error) {
      console.error("Error fetching users:", error);
      setErrorMessage("Failed to load users. Please try again later.");
      setUsers([]); 
    }
  };
  

  
  const handleConfirmDelete = async () => {
    setIsSubmitting(true); 
  
    try {
      await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/users/${userToDelete}`);
      await fetchUsers(); 
    } catch (error) {
      console.error("Error deleting user:", error);
      alert("Failed to delete user.");
    } finally {
      setIsSubmitting(false); 
      setShowConfirmModal(false);
      setUserToDelete(null);
    }
  };
    
  const handleCancelDelete = () => {
    setShowConfirmModal(false);
    setUserToDelete(null);
  };

  
  const handleDelete = async (userId) => {
    if (window.confirm("Are you sure you want to delete this user?"))
    {
      try {
        await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/users/${userId}`);
        fetchUsers(); 
      } catch (error) {
        console.error("Error deleting user:", error);
        alert("Failed to delete user.");
      }
    }
  };

  const filteredUsers = (users || []).filter((user) =>
    `${user.firstName} ${user.lastName} ${user.email} ${user.userName}`
      .toLowerCase()
      .includes(search.toLowerCase())
  );

  const indexOfLast = currentPage * usersPerPage;
  const indexOfFirst = indexOfLast - usersPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filteredUsers.length / usersPerPage);

  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div id="wrapper">
      <LoadingOverlay isVisible={isSubmitting} />

      <Sidebar userType={theUserType} />

      <div id="content-wrapper" className="d-flex flex-column">
        <div id="content">
          {/* Topbar */}
          <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
            <button
              id="sidebarToggleTop"
              className="btn btn-link d-md-none rounded-circle mr-3"
            >
              <i className="fa fa-bars"></i>
            </button>
            <ul className="navbar-nav ml-auto">
              <TopBarIcons />
            </ul>
          </nav>

          {/* Main Content */}
          <div className="container-fluid">
            <div className="view-requisition-header d-flex align-items-center justify-content-between">
              <div>
                <Link className="nav-link" to="/dashboard">
                  <i className="fas fa-arrow-left back-button"></i>
                </Link>
                <h1 className="form-heading h3 mb-4 text-gray-800">Users</h1>
              </div>

              <div className="form-group mb-0">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by name, email, or username"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </div>

            {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}

            <div className="table-responsive">
              <table className="table table-bordered table-striped table-hover">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>DP</th>
                    <th>Signature</th>
                    <th>Username</th>
                    <th>Full Name</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Position</th>
                    <th>Staff Level</th>
                    <th>Supervisor</th>
                    <th>User Type</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {currentUsers.length > 0 ? (
                    currentUsers.map((user, index) => (
                      <tr key={user.id}>
                        <td>{indexOfFirst + index + 1}</td>
                        <td>
                          {user.displayPictureFilePath ? (
                            <img
                            src={getFullImageUrl(user.displayPictureFilePath)}
                            alt="DP"
                            style={{ width: "60px", height: "60px", objectFit: "cover" }}
                          />                        
                          ) : (
                            "N/A"
                          )}
                        </td>
                        <td>
                          {user.signatureFilePath ? (
                            <img
                            src={getFullImageUrl(user.signatureFilePath)}
                            alt="Signature"
                            style={{ width: "100px", height: "40px", objectFit: "contain" }}
                            />                          
                          ) : (
                            "N/A"
                          )}
                        </td>
                        <td>{user.userName}</td>
                        <td>{user.firstName} {user.lastName}</td>
                        <td>{user.email}</td>
                        <td>{user.phoneNumber}</td>
                        <td>{user.position}</td>
                        <td>{user.staffLevel}</td>
                        <td>{user.supervisorName}</td>
                        <td>{user.userType}</td>
                        <td>
                          <button
                            className="btn btn-sm btn-warning mr-2"
                            onClick={() => navigate(`/edit-user/${user.id}`)}
                          >
                            Edit
                          </button>
                          <button className="btn btn-danger" onClick={() => handleDeleteClick(user.id)}>
                            Delete
                          </button> 
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="12" className="text-center">
                        No users found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              

              {/* Pagination */}
              {totalPages > 1 && (
                <nav>
                  <ul className="pagination justify-content-center">
                    {[...Array(totalPages).keys()].map((num) => (
                      <li
                        key={num}
                        className={`page-item ${currentPage === num + 1 ? "active" : ""}`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(num + 1)}
                        >
                          {num + 1}
                        </button>
                      </li>
                    ))}
                  </ul>
                </nav>
              )}
            </div>

            <ConfirmModal
                title="Are you sure you want to delete this user?"
                message="This action cannot be undone."
                icon={faTrash}
                iconBorder="popup-modal-icon"
                isVisible={showConfirmModal}
                onConfirm={handleConfirmDelete}
                onCancel={handleCancelDelete}
                />
          </div>
        </div>

        {/* Footer */}
        <footer className="sticky-footer bg-white">
          <div className="container my-auto">
            <div className="copyright text-center my-auto">
              <span>Copyright &copy; Farm Concern Internationalal 2025</span>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default ViewUsers;
